// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading-1 {
  font-size: 32px;
  line-height: normal;
  font-weight: 500;
  color: #142529;
}

.heading-2 {
  font-size: 24px;
  line-height: normal;
  font-weight: 600;
  color: #142529;
}

.heading-3 {
  font-size: 16px;
  line-height: normal;
  font-weight: 400;
  color: rgba(20, 37, 41, 0.5);
}

.regular-text {
  font-size: 14px;
  line-height: normal;
  font-weight: 400;
  color: rgba(20, 37, 41, 0.7);
}

.body-text {
  font-size: 12px;
  line-height: normal;
  font-weight: 500;
  color: #233A40;
}

.select-btn {
  border-radius: 16px;
  background: rgba(20, 37, 41, 0.1);
  padding: 8px;
  display: flex;
  align-items: center;
  margin: 0 8px 0 auto;
}
@media screen and (min-width: 768px) {
  .select-btn {
    margin-left: 56px;
  }
}
.select-btn__img {
  border-radius: 50%;
  overflow: hidden;
  object-fit: cover;
}
.select-btn__text {
  font-size: 14px;
  line-height: normal;
  font-weight: 500;
  color: #142529;
  margin: 0 6px;
}
.select-btn.custom-select-country {
  align-items: center;
  border: 1px solid var(--color-main-border);
  border-radius: 32px;
  margin: -6px 0 0 auto;
  padding: 5px 9px 5px 9px;
  min-width: 67px;
}
.select-btn.custom-select-country:hover {
  opacity: 1;
}
.select-btn.custom-select-country .select-btn__img {
  height: 16px;
  width: 16px;
  flex: 0 0 16px;
}
.select-btn.custom-select-country .select-btn__text {
  font-size: var(--secondary-font-size);
  font-weight: 500;
  line-height: var(--secondary-font-height);
  margin: 0 5px -1px 4px;
  text-transform: uppercase;
  color: #fff !important;
}
.select-btn.custom-select-country .arrow {
  flex: 0 0 6px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/typography.scss","webpack://./src/assets/styles/variables.scss","webpack://./src/components/Material/SelectButton/SelectButton.scss"],"names":[],"mappings":"AAEA;ECqDE,eDpDyB;ECqDzB,mBDrD+B;ECsD/B,gBDtDuC;EACrC,cAAA;AEKJ;;AFHA;ECiDE,eDhDyB;ECiDzB,mBDjD+B;ECkD/B,gBDlDuC;EACrC,cAAA;AEQJ;;AFNA;EC6CE,eD5CyB;EC6CzB,mBD7C+B;EC8C/B,gBD9CuC;EACrC,4BAAA;AEWJ;;AFTA;ECyCE,eDxCyB;ECyCzB,mBDzC+B;EC0C/B,gBD1CuC;EACrC,4BAAA;AEcJ;;AFZA;ECqCE,eDpCyB;ECqCzB,mBDrC+B;ECsC/B,gBDtCuC;EACrC,cAAA;AEiBJ;;AAlCA;EACI,mBAAA;EACA,iCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AAqCJ;ADvBI;ECpBJ;IAQQ,iBAAA;EAuCN;AACF;AAtCI;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;AAwCR;AAtCI;EDqCF,eCpC6B;EDqC7B,mBCrCmC;EDsCnC,gBCtC2C;EACrC,cAAA;EACA,aAAA;AA0CR;AAxCI;EAII,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,qBAAA;EACA,wBAAA;EACA,eAAA;AA0CR;AAzCQ;EACI,UAAA;AA2CZ;AAzCQ;EACI,YAAA;EACA,WAAA;EACA,cAAA;AA2CZ;AAzCQ;EACI,qCAAA;EACA,gBAAA;EACA,yCAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AA2CZ;AAzCQ;EACE,aAAA;AA2CV","sourcesContent":["@import \"./variables.scss\";\n\n.heading-1{\n    @include fontVariation(32px, normal, 500);\n    color: #142529;\n}\n.heading-2{\n    @include fontVariation(24px, normal, 600);\n    color: #142529;\n}\n.heading-3{\n    @include fontVariation(16px, normal, 400);\n    color: rgba(20, 37, 41, 0.50);\n}\n.regular-text{\n    @include fontVariation(14px, normal, 400);\n    color: rgba(20, 37, 41, 0.70);\n}\n.body-text{\n    @include fontVariation(12px, normal, 500);\n    color: #233A40;\n}\n","@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@500;700&display=swap');\n\n@import \"color-variables\";\n\n$intel: 'Inter', sans-serif;\n$montserrat: 'Montserrat', sans-serif;\n$sfCompact: 'SF-Compact', sans-serif;\n$brutalType: 'BrutalType', sans-serif;\n\n// BREAKPOINTS\n$media-xs: 486px;\n$media-sm: 768px;\n$media-md: 1024px;\n$media-lg: 1200px;\n$media-xl: 1440px;\n\n@mixin screen($size, $type: min, $pixels: $media-xs) {\n  @if $size == \"xs\" {\n    @media screen and ($type + -width: $media-xs) {\n      @content;\n    }\n  } @else if $size == \"sm\" {\n    @media screen and ($type + -width: $media-sm) {\n      @content;\n    }\n  } @else if $size == \"md\" {\n    @media screen and ($type + -width: $media-md) {\n      @content;\n    }\n  } @else if $size == \"lg\" {\n    @media screen and ($type + -width: $media-lg) {\n      @content;\n    }\n  } @else if $size == \"xlg\" {\n    @media screen and ($type + -width: $media-xl) {\n      @content;\n    }\n  } @else if $size == \"custom\" {\n    @media screen and ($type + -width: $pixels + px) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n//BETWEEN BREAKPOINTS\n@mixin media-breakpoint-between($minW, $maxW) {\n  @media screen and (min-width: $minW - 1px) and (max-width: $maxW) {\n    @content;\n  }\n}\n\n@mixin fontVariation($size: \"16px\", $weight: \"500\", $lineHeight: \"20px\") {\n  font-size: $size;\n  line-height: $weight;\n  font-weight: $lineHeight;\n}\n\n@mixin lineClamp($line) {\n  display: -webkit-box;\n  -webkit-line-clamp: #{$line};\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin scrollBar($width, $height) {\n  &::-webkit-scrollbar {\n    width: $width;\n    height: $height;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #e1e6ec;\n    border-radius: 8px;\n  }\n}\n\n%positioned {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n}\n\n%flex-centered {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n","@use \"../../../assets/styles/typography\";\n@import \"../../../assets/styles/variables\";\n\n.select-btn{\n    border-radius: 16px;\n    background: rgba(20, 37, 41, 0.10);\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    margin: 0 8px 0 auto;\n    @include screen(sm) {\n        margin-left: 56px;\n    }\n    &__img{\n        border-radius: 50%;\n        overflow: hidden;\n        object-fit: cover;\n    }\n    &__text{\n        @include fontVariation(14px, normal, 500);\n        color: #142529;\n        margin: 0 6px;\n    }\n    &.custom-select-country{\n        -webkit-box-align: center;\n        -moz-box-align: center;\n        -webkit-align-items: center;\n        align-items: center;\n        border: 1px solid var(--color-main-border);\n        border-radius: 32px;\n        margin: -6px 0 0 auto;\n        padding: 5px 9px 5px 9px;\n        min-width: 67px;\n        &:hover{\n            opacity: 1;\n        }\n        .select-btn__img{\n            height: 16px;\n            width: 16px;\n            flex: 0 0 16px;\n        }\n        .select-btn__text{\n            font-size: var(--secondary-font-size);\n            font-weight: 500;\n            line-height: var(--secondary-font-height);\n            margin: 0 5px -1px 4px;\n            text-transform: uppercase;\n            color: #fff!important;\n        }\n        .arrow{\n          flex: 0 0 6px;\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
